import { Skeleton } from "@gearbox-protocol/ui-kit";

export function SkeletonBytecodeDetails() {
  return (
    <div className="space-y-6">
      <Skeleton className="h-32 w-full" />
      <div className="grid grid-cols-1 md:grid-cols-[1fr_400px] gap-6 mb-8 min-h-[300px]">
        {/* Source Code */}
        <Skeleton className="h-full max-h-[300px] md:max-h-[400px] w-full" />
        <Skeleton className="h-full w-full" />
      </div>

      {/* Deployed Contracts */}
      <div>
        <h2 className="text-xl font-semibold mb-4 text-foreground">
          Deployed Contracts
        </h2>
        <Skeleton className="h-64 w-full" />
      </div>
    </div>
  );
}
